'use client';

import React from 'react';
import BottomNav from '@/components/BottomNav';
import TopSearchBar from '@/components/TopSearchBar';
import NotificationsContent from './components/NotificationsContent';

export default function NotificationsPage() {
  return (
    <main className="min-h-screen pb-24" style={{ background: 'var(--background)', color: 'var(--foreground)' }}>
      <TopSearchBar />
      <NotificationsContent />
      <BottomNav />
    </main>
  );
}
